'use client';

import {
  CircularProgress,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import { stickNameCell, StyledHeaderTableCell, StyledTable } from '~/shared';
import { CampaignProductReport } from '~/types';

import { useGetSponsoredProductsReportsCampaign } from '../../hooks';

import { SponsoredProductsReportCampaignRow } from './Row';

export type SponsoredProductsReportCampaignListProps = {
  getReportsCampaignQuery: ReturnType<
    typeof useGetSponsoredProductsReportsCampaign
  >;
  advertiserId: string;
  campaignId: string;
};

export function SponsoredProductsReportCampaignList({
  getReportsCampaignQuery,
  advertiserId,
  campaignId,
}: SponsoredProductsReportCampaignListProps) {
  const { data, isLoading, isError, error } = getReportsCampaignQuery;

  return (
    <StyledTable aria-label="Tabela de Banners de Produtos Patrocinados">
      <TableHead>
        <TableRow>
          <StyledHeaderTableCell sx={stickNameCell()}>
            Nome do Produto
          </StyledHeaderTableCell>
          <StyledHeaderTableCell>SKU</StyledHeaderTableCell>
          <StyledHeaderTableCell>Cliques</StyledHeaderTableCell>
          <StyledHeaderTableCell>Impressões</StyledHeaderTableCell>
          <StyledHeaderTableCell>CTR</StyledHeaderTableCell>
          <StyledHeaderTableCell>CPM</StyledHeaderTableCell>
          <StyledHeaderTableCell>CPC</StyledHeaderTableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {isLoading && (
          <TableRow>
            <TableCell component="th" scope="row" colSpan={8} align="center">
              <CircularProgress size={15} /> Carregando
            </TableCell>
          </TableRow>
        )}

        {!isLoading && !isError && data?.list?.length === 0 && (
          <TableRow>
            <TableCell colSpan={8} align="center">
              Sem resultados
            </TableCell>
          </TableRow>
        )}

        {isError && (
          <TableRow>
            <TableCell
              sx={{ color: theme => theme.palette.error.light }}
              colSpan={8}
              align="center"
            >
              <Typography>Ocorreu um erro: {error?.name}</Typography>
              <Typography>{error?.message}</Typography>
            </TableCell>
          </TableRow>
        )}

        {!isLoading &&
          !isError &&
          data?.list?.map((resume: CampaignProductReport) => {
            return (
              <SponsoredProductsReportCampaignRow
                key={resume.nome}
                resume={resume}
                advertiserId={advertiserId}
                campaignId={campaignId}
              />
            );
          })}
      </TableBody>
    </StyledTable>
  );
}
